import { useMutation } from '@tanstack/react-query';

import { InitiateVendorCallsDto, InitiateVendorCallsResponse } from '@/api/models/vendor';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export const useInitiateVendorCalls = () => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async (data: InitiateVendorCallsDto) =>
      handleApiCall<InitiateVendorCallsResponse, InitiateVendorCallsDto>(
        session,
        'POST',
        'vendor/initiate-calls',
        data
      ),
  });
};